import type { MessageDescriptor } from 'react-intl';
import { defineMessages } from 'react-intl';

const messages = defineMessages({
  taxIdentifierType: {
    description: 'Tax Identifiers tax id type',
    defaultMessage: 'Tax ID Type',
    id: 'MxVcnj',
  },
  taxNumber: {
    description: 'Tax identifier Number',
    defaultMessage: 'Number',
    id: 'Ww9tyI',
  },
  taxNickname: {
    description: 'Tax identifier Nickname',
    defaultMessage: 'Nickname',
    id: 'KBGhWM',
  },
  taxIssuingAuthority: {
    description: 'Tax identifier Issuing Authority',
    defaultMessage: 'Issuing Authority',
    id: 'vFDYbk',
  },
  taxDescription: {
    description: 'Tax identifier Description',
    defaultMessage: 'Description',
    id: 'b7affs',
  },
});
type TaxIdentifierTranslation = {
  [key in keyof typeof messages]: {
    key: string;
    messageDescriptor?: MessageDescriptor;
  };
};
export const TaxIdentifiers: TaxIdentifierTranslation = {
  taxIdentifierType: { key: 'TaxIdentifierType' },
  taxNumber: { key: 'TaxNumber' },
  taxNickname: { key: 'TaxNickname' },
  taxIssuingAuthority: { key: 'TaxIssuingAuthority' },
  taxDescription: { key: 'TaxDescription' },
};

Object.keys(TaxIdentifiers).forEach((taxIdentifier: string) => {
  const taxIdentifierKey = taxIdentifier as keyof typeof TaxIdentifiers;
  if (messages[taxIdentifierKey]) {
    TaxIdentifiers[taxIdentifierKey].messageDescriptor = messages[taxIdentifierKey];
  }
});
